import styled from "@emotion/styled";
import { Customer } from "../../types/types";
import SelectBox, { menuItemType } from "../selectBox";
import { useState } from "react";
import useGetUserGroup from "../../hooks/useGetUserGroup";
import theme from "../../theme";
import { useWindowSize } from "@reactuses/core";
import { Label } from "../common/Label";
import { TextInput } from "../common/TextInput";
import { useI18n } from "../../locales";
//import { SrLable } from "../common/SrLabel";

const { sm, md } = theme.screen;

const InputField: React.FC<{ data?: Customer }> = (props) => {
  const { data } = props;
  const { width } = useWindowSize();
  const [group] = useState("");
  const { data: GroupOptions } = useGetUserGroup({ group });
  const { t } = useI18n();
  const userGroupType: menuItemType[] = [];
  if (GroupOptions) {
    for (let i = 0; i < GroupOptions.length; i++) {
      userGroupType.push({
        value: GroupOptions[i].group_id,
        title: GroupOptions[i].name,
      });
    }
  }

  // console.log(data);
  return (
    <UserInfoWrapper>
      <UserInfo>
        <FirstRow>
          <InputWrapper>
            <Label text={t.manageCustomer.ownerName} htmlFor="name" />

            <TextInput
              disabled
              value={data?.name ?? ""}
              id="name"
              name="name"
              width={"200px"}
              readOnly
            />
          </InputWrapper>
          <InputWrapper>
            <Label text={t.manageCustomer.ownerContact} htmlFor="phone" />
            <TextInput
              disabled
              value={data?.phone ?? ""}
              id="phone"
              name="phone"
              width={"200px"}
              readOnly
            />
          </InputWrapper>
        </FirstRow>
        {/* <SecondRow>
          <InputWrapper>
            <Label text="주민번호 앞자리" htmlFor="birth" />

            <ResidentNumWrapper>
              <TextInput
                disabled
                value={data?.birth ? String(data?.birth) : ""}
                id="birth"
                name="birth"
                width={"200px"}
                readOnly
              />
              <span>{`-`}</span>

              <BackNumber>
                <SrLable
                  labelText={`주민번호 뒷자리 첫번째 숫자`}
                  id="sex"
                />
                <TextInput
                  disabled
                  value={data?.sex ? String(data?.sex) : ""}
                  id="sex"
                  name="sex"
                  width={"50px"}
                  readOnly
                />
                <span>******</span>
              </BackNumber>
            </ResidentNumWrapper>
          </InputWrapper>
        </SecondRow> */}
        <ThirdRow>
          <InputWrapper style={{ marginBottom: "26px" }}>
            <Label text={t.manageCustomer.address} htmlFor="address" />
            <TextInput
              disabled
              value={data?.address ?? ""}
              id="address"
              name="address"
              width={"100%"}
              readOnly
            />
          </InputWrapper>
          <InputWrapper style={{ marginBottom: "26px" }}>
            <Label text={t.manageCustomer.detailAddress} htmlFor="address_detail" />

            <TextInput
              disabled
              value={data?.address_detail ?? ""}
              id="address_detail"
              name="address_detail"
              width={"100%"}
              readOnly
            />
          </InputWrapper>
          <FirstRow>
            <InputWrapper>
              <Label text={t.manageCustomer.other} htmlFor="illness" />
              <TextInput
                disabled
                value={data?.illness ?? ""}
                id="illness"
                name="illness"
                width={"200px"}
                readOnly
              />
            </InputWrapper>
            <InputWrapper>
              {/* <Label text="담당기관" htmlFor="gov_id" /> */}
              <Label text={t.manageCustomer.groupLabel} htmlFor="gov_id" />

              <SelectBox
                disabled
                filter={data?.group_id || "00000"}
                menuItems={userGroupType}
                width={width <= md ? "100%" : "200px"}
                mr="0px"
                // isWhite={true}
                srLabel={t.manageCustomer.groupLabel}
              />
            </InputWrapper>
          </FirstRow>
          <InputWrapper style={{ marginBottom: "26px" }}>
            <Label text={t.manageCustomer.password} htmlFor="pw" />

            <TextInput
              disabled
              value="****"
              id="pw"
              name="pw"
              width={"100%"}
              readOnly
            />
          </InputWrapper>
          <InputWrapper style={{ marginBottom: "26px" }}>
            <Label text={t.manageCustomer.joinDate} htmlFor="registered_at" />

            <TextInput
              disabled
              value={data?.registered_at ?? ""}
              id="registered_at"
              name="registered_at"
              width={"100%"}
              readOnly
            />
          </InputWrapper>
          <div style={{ marginLeft: "10px" }}></div>
          <InputWrapper style={{ width: "10px" }}></InputWrapper>
        </ThirdRow>
      </UserInfo>
    </UserInfoWrapper>
  );
};

const UserInfoWrapper = styled.div`
  background: ${theme.color.neutral_50};
  border-radius: 10px;
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 30px;
  padding-bottom: 30px;
  width: 100%;
  display: flex;
  gap: 44px;
  margin-bottom: 40px;

  @media (max-width: ${sm}px) {
    padding: 10px;
  }
`;

const UserInfo = styled.div`
  width: 100%;
`;

const FirstRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 26px;

  @media (max-width: ${md}px) {
    flex-direction: column;
    gap: 26px;
  }
`;

// const SecondRow = styled.div`
//   display: flex;
//   width: 100%;
//   justify-content: space-between;
//   margin-bottom: 26px;
// `;

const ThirdRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${sm}) {
    width: 100%;
  }
  @media (min-width: (${sm + 1})) and (max-width: ${md}) {
    width: 100%;
  }
`;

// const BackNumber = styled.div`
//   display: flex;
//   gap: 20px;
//   align-items: center;
//   width: 190px;

//   @media (max-width: ${md}px) {
//     gap: 5px;
//     width: 100%;

//     span {
//       font-size: 14px;
//     }
//   }
// `;

// const ResidentNumWrapper = styled.div`
//   display: flex;
//   gap: 20px;
//   align-items: center;
//   justify-content: space-between;
//   @media (max-width: ${md}px) {
//     gap: 5px;
//   }
// `;

export default InputField;
